@if (keyAsNumber === field.parent?.model?.length - 1) {
  <div
    data-test-id="new"
    class="group mb-6 rounded-lg border-2 border-dashed border-grey-300 bg-grey-50 p-5"
  >
    <ng-container #fieldComponent />
  </div>
} @else {
  <div
    data-test-id="existing"
    class="group relative mb-6 rounded-lg border-2 border-grey-300 bg-white p-5"
  >
    <ng-container #fieldComponent />
    <app-button
      data-test-id="removeButton"
      type="transparent"
      shape="circle"
      class="absolute top-3 right-5 text-grey-600"
      (trigger)="field.parent?.props?.remove(field.key)"
    >
      <svg-icon src="assets/icons/General/trash-01.svg" />
    </app-button>
  </div>
}
